<script>
  export let message = '';
  export let code = '';
</script>

<div class="grid h-screen px-4 bg-white place-content-center">
  <div class="text-center flex items-center flex-col gap-3">
    <div class="">
      <svg
        height="150px"
        width="150px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xml:space="preserve"
      >
        <path
          style="fill:#FF6465;"
          d="M256.001,8.505C119.314,8.505,8.507,119.313,8.507,256s110.807,247.495,247.495,247.495
    S503.496,392.688,503.496,256S392.689,8.505,256.001,8.505z"
        />
        <path
          style="opacity:0.1;enable-background:new    ;"
          d="M76.55,256c0-125.143,92.887-228.574,213.473-245.156
    c-11.124-1.53-22.477-2.338-34.022-2.338C119.314,8.505,8.507,119.313,8.507,256s110.807,247.495,247.495,247.495
    c11.545,0,22.898-0.809,34.022-2.338C169.437,484.574,76.55,381.143,76.55,256z"
        />
        <path
          style="fill:#FFFFFF;"
          d="M404.376,282.199c0,8.099-6.565,14.665-14.665,14.665H122.288c-8.099,0-14.665-6.565-14.665-14.665
    V229.8c0-8.099,6.565-14.665,14.665-14.665h267.423c8.099,0,14.665,6.565,14.665,14.665V282.199z"
        />
        <path
          d="M256.001,512c-40.795,0-81.385-9.837-117.383-28.447c-34.824-18.003-65.55-44.247-88.858-75.891
    c-2.786-3.782-1.978-9.107,1.804-11.892c3.782-2.785,9.107-1.979,11.892,1.804c21.767,29.554,50.459,54.059,82.974,70.869
    C180.503,486.058,217.368,494.99,256,494.99c131.779,0,238.989-107.21,238.989-238.989c0-31.734-6.131-62.574-18.222-91.662
    c-1.803-4.338,0.252-9.315,4.588-11.118c4.337-1.803,9.315,0.251,11.118,4.588c12.957,31.167,19.525,64.204,19.525,98.192
    c0,68.379-26.629,132.667-74.981,181.019C388.668,485.371,324.381,512,256.001,512z M35.551,377.101
    c-3.091,0-6.073-1.691-7.578-4.632C9.412,336.202,0.001,297.016,0.001,256c0-68.379,26.629-132.667,74.981-181.019
    S187.621,0,256.001,0c44.641,0,88.593,11.666,127.104,33.738c37.345,21.403,68.961,52.135,91.433,88.875
    c2.452,4.007,1.19,9.243-2.818,11.693c-4.007,2.452-9.243,1.19-11.693-2.818c-20.984-34.308-50.508-63.006-85.38-82.992
    c-35.94-20.598-76.967-31.486-118.645-31.486C124.222,17.011,17.012,124.221,17.012,256c0,38.295,8.782,74.874,26.103,108.719
    c2.14,4.182,0.485,9.307-3.697,11.447C38.178,376.8,36.855,377.101,35.551,377.101z M389.713,305.369H122.289
    c-12.776,0-23.17-10.394-23.17-23.17V229.8c0-12.776,10.394-23.17,23.17-23.17h267.423c12.776,0,23.17,10.395,23.17,23.17v52.399
    C412.882,294.975,402.488,305.369,389.713,305.369z M122.289,223.642c-3.397,0-6.159,2.764-6.159,6.159V282.2
    c0,3.397,2.763,6.159,6.159,6.159h267.423c3.397,0,6.159-2.763,6.159-6.159v-52.399c0-3.397-2.763-6.159-6.159-6.159H122.289z"
        />
      </svg>
    </div>

    <h1 class="font-black text-slate-200 text-9xl">{code}</h1>

    <p class="text-2xl font-bold tracking-tight text-slate-900 sm:text-4xl">Uh-oh!</p>

    <p class="mt-4 text-slate-600">
      {message}
    </p>

    <a class="text-indigo-600 font-semibold" data-sveltekit-reload href="/">Go Home</a>
  </div>
</div>
